import React from 'react';
import { InputGroup, Button, FloatingLabel, Row, Col } from 'react-bootstrap';
import { Formik, Form, useFormikContext } from 'formik';
import { useSearchParams } from 'react-router-dom';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OrderStatuses, tOrderStatus } from '@models/Order';
import { OrderTypes, tOrderType } from '@models/Order';
import { FormikControl, FormikSelect } from '@components/Base';
import { mergeInitialValues } from '@utils/formik';
import { useUpdateEffect } from 'usehooks-ts';

type FormValues = {
  search: string;
  status: OrderStatuses | '' | 'renewable';
  orderType: OrderTypes | '';
}

const FormForm = () => {
  const { t } = useTranslation();
  const [, setSearchParams] = useSearchParams();
  const { values } = useFormikContext<FormValues>();
  const { status, orderType } = values;

  useUpdateEffect(() => {
    setSearchParams({ orderType, status });
  }, [status, orderType]);

  return (
    <Form>
      <Row>
        <Col xs={3}>
          <FloatingLabel label={t('common:orderType')}>
            <FormikSelect name="orderType" isValid={false} isInvalid={false}>
              <option value="">{t('common:all')}</option>
              {map(OrderTypes, (value,) => (
                <option key={value} value={value}>{tOrderType(value)}</option>
              ))}
            </FormikSelect>
          </FloatingLabel>
        </Col>

        <Col xs={3}>
          <FloatingLabel label={t('common:status')}>
            <FormikSelect name="status" isValid={false} isInvalid={false}>
              <option value="">{t('common:all')}</option>
              <option value="renewable">{t('common:renewable')}</option>
              {map(OrderStatuses, (value,) => (
                <option key={value} value={value}>{tOrderStatus(value)}</option>
              ))}
            </FormikSelect>
          </FloatingLabel>
        </Col>

        <Col>
          <InputGroup>
            <FloatingLabel label={t('order.search')} style={{ flex: '1 1 auto', width: '1%', minWidth: '0' }}>
              <FormikControl name="search" isValid={false} isInvalid={false} />
            </FloatingLabel>
            <Button type="submit">
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
        </Col>
      </Row >
    </Form>
  )
}

const OrderControlForm = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams);
  const values: FormValues = { status: '', search: '', orderType: '' };
  const initialValues = mergeInitialValues(values, params);

  const handleSubmit = ({ search }: FormValues) => {
    setSearchParams({ search });
  }

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      <FormForm />
    </Formik >
  );
}

export { OrderControlForm };
